import React, { useState, useEffect } from 'react';
import AresNavBar from './../Layout/NavBar/NavBar'
import SideBar from '../Layout/SideBar/SideBar'

import './index.css'
import { Col, Row, Spinner, Container } from 'react-bootstrap';
import { FaRegBell, FaTelegram } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { IoMdMail, IoLogoWhatsapp } from 'react-icons/io';
import Switch from "react-switch";

import client from "../../services/Api";

function Settings() {
	const [push, setPush] = useState(false)
	const [mail, setMail] = useState(false)
	const [sms, setSms] = useState(false)
	const [telegram, setTelegram] = useState(false)
	const [whats, setWhats] = useState(false)

	const [loading, setLoading] = useState(true)

	useEffect(() => {
		init()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function init() {
		setLoading(true);
		const response = await getSettings();
		if (response !== null) {
			response.data.forEach(value => {
				switch (value) {
					case 'push':
						setPush(false);
						break;
					case 'email':
						setMail(false);
						break;
					case 'sms':
						setSms(false);
						break;
					case 'telegram':
						setTelegram(false);
						break;
					case 'whatsapp':
						setWhats(false);
						break;
				}
			});
		}
		setLoading(false);
	}

	async function getSettings() {
		try {
			const response = await client.get('/api/me/config/notification-channel');
			return response;
		} catch (e) {
			console.log(e);
		}
		return null;
	}

	function handlePush() {
		if (!push) {
			setChannel('push');
		} else {
			unsetChannel('push');
		}
		setPush(!push);
	}
	function handleMail() {
		if (!mail) {
			setChannel('email');
		} else {
			unsetChannel('email');
		}
		setMail(!mail);
	}
	function handleSms() {
		if (!sms) {
			setChannel('sms');
		} else {
			unsetChannel('sms');
		}
		setSms(!sms);
	}
	function handleTelegram() {
		if (!telegram) {
			setChannel('telegram');
		} else {
			unsetChannel('telegram');
		}
		setTelegram(!telegram);
	}
	function handleWhats() {
		if (!whats) {
			setChannel('whatsapp');
		} else {
			unsetChannel('whatsapp');
		}
		setWhats(!whats);
	}

	function renderLoading() {
		return (
			<div className="center-page">
				<Spinner animation="border" />
			</div>
		)
	}

	async function setChannel(value) {
		try {
			const response = await client.post('/api/me/config/notification-channel', { "channel": value });
			console.log(response);
		} catch (e) {
			console.log(e);
		}
	}
	async function unsetChannel(value) {
		try {
			const response = await client.delete('/api/me/config/notification-channel', { "data": { "channel": value } });
			console.log(response);
		} catch (e) {
			console.log(e);
		}
	}

	return (
		<div className="settings">
			<AresNavBar />
			<SideBar />
			<div className="container-header">
				<h1>Configurações</h1>
				<div className="subtitle">
					<span>Por onde deseja receber notificações?</span>
				</div>
			</div>
			{loading ?
				renderLoading()
				:
				<div className="container-notifications">
					<Container fluid>
						<div className="body">
							{/* <div className="container-header">
                            <h1>Configurações</h1>
                            <h4>Alertas</h4>
                            <h5>Por onde deseja receber notificações?</h5>
                        </div> */}
							<div className="alert-container">
								<Row md={4} lg={4}>
									<Col>
										<FaRegBell className="icon icon-color" />
                    Notificação push
                  </Col>
									<Col className="bottom" xs={4} lg={6}>
										<Switch className='switch' onChange={handlePush} checked={push} uncheckedIcon={false} checkedIcon={false} onColor="#29c536" disabled />
									</Col>
								</Row>
								<Row md={4} lg={4}>
									<Col>
										<FiMail className="icon icon-color" />
                    Email
                  </Col>
									<Col className="bottom" xs={4} lg={6}>
										<Switch  className='switch' onChange={handleMail} checked={mail} uncheckedIcon={false} checkedIcon={false} onColor="#29c536" disabled />
									</Col>
								</Row>
								<Row md={4} lg={4}>
									<Col>
										<IoMdMail className="icon sms" />
										SMS
								</Col>
									<Col className="bottom" xs={4} lg={6}>
										<Switch className='switch' onChange={handleSms} checked={sms} uncheckedIcon={false} checkedIcon={false} onColor="#29c536" disabled />
									</Col>
								</Row>
								<Row md={4} lg={4}>
									<Col>
										<FaTelegram className="icon telegram" />
											Telegram
									</Col>
									<Col className="bottom" xs={4} lg={6}>
										<Switch className='switch' onChange={handleTelegram} checked={telegram} uncheckedIcon={false} checkedIcon={false} onColor="#29c536" disabled />
									</Col>
								</Row>
								<Row md={4} lg={4}>
									<Col>
										<IoLogoWhatsapp className="icon whatsapp" />
											Whatsapp
									</Col>
									<Col className="bottom" xs={4} lg={6}>
										<Switch className='switch' onChange={handleWhats} checked={whats} uncheckedIcon={false} checkedIcon={false} onColor="#29c536" disabled />
									</Col>
								</Row>
							</div>

							{/* <div className="about">
								<Row>
									<div>
										<h4>Sobre</h4>
									</div>
								</Row>
								<div>
									<Row>
										<Col>
											<a href="https://terms.guiadobem.com.br/">Termos de uso</a>

										</Col>
									</Row>
									<Row>
										<Col>
											<a href="https://privacy.guiadobem.com.br/">Política de privacidade</a>

										</Col>
									</Row>
								</div>
							</div> */}
						</div>
					</Container>
				</div>
			}
		</div>
	);
}

export default Settings;